export enum NotificationBannerType {
  Info = 'mw-info',
  Warn = 'mw-warning',
  Success = 'mw-success',
  Error = 'mw-error',
  Custom = 'mw-custom',
}
